import Nav from '../components/Nav';
import heroimageS from "../assets/images/small/Nadine&JP-24.webp"
import heroimageL from "../assets/images/big/Nadine&JP-24.jpg"
import conradHotel from "../assets/images/accomodation/conrad.jpeg";
import diamondHotel from "../assets/images/accomodation/diamond.jpeg";
import dusitThani from "../assets/images/accomodation/dusit-thani.jpeg";
import henryHotel from "../assets/images/accomodation/henry-hotel.jpeg";
import holidayInn from "../assets/images/accomodation/holiday-inn.jpeg";
import manilaHotel from "../assets/images/accomodation/manila-hotel.jpeg";
import newWorld from "../assets/images/accomodation/new-world.jpeg";
import peninsula from "../assets/images/accomodation/peninsula.jpeg";
import rizalPark from "../assets/images/accomodation/rizal-park.jpeg";
import summitMagnolia from "../assets/images/accomodation/summit-hotel.jpeg";
import summitGreenhills from "../assets/images/accomodation/summit-hotel.webp";
import newManila from "../assets/images/accomodation/new-manila.jpeg";

import Hero from '../components/Hero';
import {
  Box,
  Grid,
  Container,
  Typography,
  Link,
} from '@mui/material';

// TODO: add correct paths for images
const metroManila = [
  {name:"The Henry Hotel", path: henryHotel, link: "https://manila.thehenryhotel.com/"},
  {name:"The Manila Hotel", path: manilaHotel, link: "https://www.manila-hotel.com.ph/"},
  {name:"The Conrad Hotel", path: conradHotel, link: "https://www.hilton.com/en/hotels/mnlmbci-conrad-manila/?SEO_id=GMB-APAC-CI-MNLMBCI"},
  {name:"The Diamond Hotel", path: diamondHotel, link: "https://www.diamondhotel.com/"},
  {name:"Rizal Park Hotel", path: rizalPark, link: "https://www.rizalparkhotel.com.ph/"},
];

const makati = [
  {name:"Holiday Inn", path: holidayInn, link: "https://www.ihg.com/holidayinn/hotels/us/en/makati/mnlgs/hoteldetail"},
  {name:"New World Makati Hotel", path: newWorld, link: "https://manila.newworldhotels.com/en/"},
  {name:"The Peninsula Makati", path: peninsula, link: "https://www.peninsula.com/en/manila/5-star-luxury-hotel-makati"},
  {name:"Dusit Thani Manila", path: dusitThani, link: "https://www.dusit.com/dusitthani-manila/?utm_source=affilired&_affclk=adn%3A3817%3A%3ACj0KCQjw-pCVBhCFARIsAGMxhAcQ9fM-5-hgl5564t8RXbkHfTPWjYEyUWSFmsCdoC1QDUGETaVN3agaAjsmEALw_wcB%3A8002y1"},
];

const sanJuanCity = [
  {name:"Summit Hotel Magonlia", path: summitMagnolia, link: "https://www.summithotels.ph/hotels/summit-hotel-magnolia"},
  {name:"Summit Hotel Greenhills", path: summitGreenhills, link: "https://www.summithotels.ph/hotels/summit-hotel-greenhills"},
  {name:"New Manila Suites", path: newManila, link: "https://new-manila-suites.getmanilahotels.com/en/"},
];

function AccomodationImages(props) {
 return (
   <Grid
    container
    columnSpacing={1}
    rowSpacing={2}
    className="hotel-images"
    justifyContent="flex-start"
   >
     {props.images.map(image => {
       return (
         <Grid item xs={6} md={4} display="flex">
           <Box>
             <Link href={image.link} underline="hover" rel="noreferrer" target="_blank">
              <Box 
                className="hotel-image"
                src={image.path}
                sx={{width: {xs: '43vw', sm: "45vw", md: "30vw", lg: "350px"}, objectFit: "cover", height: {xs: '260px', sm: "350px", md: "350px", lg: "390px"}}}
                alt={image.name}
                component="img"
              />
              <Typography variant="body1">{image.name}</Typography>
            </Link>
           </Box>
         </Grid>
       )
     })}
   </Grid>
 )
};

export default function Stay() {
    // TODO: fix padding
  return (
    <>
      <Nav />
      <Hero name="STAY" imageS={heroimageS} imageL={heroimageL} />
      <Box textAlign="left" 
        sx={{ padding: { xs: '2em 0 5em 0' }}}
      >
        <Container maxWidth="lg">
          <Typography variant="h3" textAlign="left" pb="2em" pt="2em">Here's some recommended places to stay</Typography>
          <Typography variant="h2">Metro Manila</Typography>
          <Typography variant="body1" pb="2em">This is the closest location to the church venue.</Typography>
          <AccomodationImages images={metroManila}/>
        </Container>
      </Box>
      <Box textAlign="left" sx={{backgroundColor: "#F0E6DC", padding: { xs: '5em 0 5em 0' }}}>
        <Container maxWidth="lg">
          <Typography variant="h2">Makati</Typography>
          <Typography variant="body1">Roughly a midway point between the church and the reception</Typography>
          <Typography variant="body1" pb="2em">(A great area to stay for shopping lovers!)</Typography>
          <AccomodationImages images={makati}/>
        </Container>
      </Box>
      <Box textAlign="left"
        sx={{ padding: { xs: '5em 0 5em 0' }}}
      >
        <Container maxWidth="lg">
          <Typography variant="h2">San Juan City</Typography>
          <Typography variant="body1" pb="2em">The closest location to the reception.</Typography>
          <AccomodationImages images={sanJuanCity}/>
        </Container>
      </Box>
    </>
  );
}